<template>
  <div id='engManage'>
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#engManage{
  height :100%;
  width :100%;
}
</style>